import { render, staticRenderFns } from "./Scattergories.vue?vue&type=template&id=27b916e5&scoped=true&"
import script from "./Scattergories.vue?vue&type=script&lang=js&"
export * from "./Scattergories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b916e5",
  null
  
)

export default component.exports